/**
 * @module app.pm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { NavigationInstruction, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { CustomFieldService } from 'app/core/services/custom-field-service';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class UserDefinedField extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected userDefinedFieldDefinitionId: string | null = null;
    // To load necessary user defined field information
    protected userDefinedFieldDefinition: Core.CustomFieldDefinition | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly customFieldService: CustomFieldService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: { userDefinedFieldDefinitionId: string }): Promise<boolean> {
        await this.accountContext.load();

        if(!params.userDefinedFieldDefinitionId) { throw new Error('Missing required parameters: userDefinedFieldDefinitionId'); }

        const userDefinedFieldDefinitionRoute: string = params.userDefinedFieldDefinitionId ? `pm.admin.user-defined-field.${params.userDefinedFieldDefinitionId}` : '';
        if(!this.accountContext.hasRouteAccess(userDefinedFieldDefinitionRoute)) { return false; }

        return true;
    }

    protected async activate(params: { userDefinedFieldDefinitionId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.userDefinedFieldDefinitionId) {
            throw new Error('Missing required parameters: userDefinedFieldDefinitionId');
        }

        this.userDefinedFieldDefinitionId = params.userDefinedFieldDefinitionId;

        await this.loadUserDefinedFieldDefinitionInformation(this.userDefinedFieldDefinitionId);

        // Set up Page Title
        if(routeConfig.navModel) {
            const title = this.i18n.tr('pm:routes.admin.user-defined-field.$title', { what: this.userDefinedFieldDefinition?.description });
            routeConfig.navModel.setTitle(title);
        }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadUserDefinedFieldDefinitionInformation(userDefinedFieldDefinitionId: string): Promise<void> {
        try {
            this.state.beginLoad();

            const response = await this.customFieldService.loadCustomFieldDefinition(userDefinedFieldDefinitionId);
            this.userDefinedFieldDefinition = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }

}
